import Axios from "axios";

export default Axios.create({
  baseURL: "https://salty-island-31096.herokuapp.com"
});
